module.exports = __webpack_public_path__ + "static/img/lady_computer.6ef6dc6f.jpg";